import { render, staticRenderFns } from "./DictionaryAcceptanceWordsNew.vue?vue&type=template&id=1cad2a36&"
import script from "./DictionaryAcceptanceWordsNew.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWordsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports